import { useTranslation } from 'react-i18next';
import { Dialog } from '../design-system';
import { getTierDisplayName } from '@papper/shared/reedle/tiers';

const UsageUpgradeSuccessModal = ({ onClose, confirmModal }) => {
  const { t } = useTranslation('modals');
  return (
    <Dialog
      isOpen
      onClose={onClose}
      ariaLabel={t('usage.plan.upgradeSuccessTitle')}
      showClose={false}
      className="usage-coming-soon-modal success"
    >
      <div className="success-icon">✓</div>
      <h3>{t('usage.plan.upgradeSuccessTitle')}</h3>
      <p>{t('usage.plan.upgradeSuccessMessage', {
        tier: getTierDisplayName(confirmModal.targetTier)
      })}</p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginTop: '4px' }}>
        <button
          className="usage-confirm-btn confirm success-done"
          onClick={onClose}
        >
          {t('common.done', { defaultValue: 'Done' })}
        </button>
      </div>
    </Dialog>
  );
};

export default UsageUpgradeSuccessModal;
